<core-loading [visible]="false"></core-loading>

<app-donation-ticket-modal
  *ngIf="showDonationModal && donationTicketType"
  [ticketType]="donationTicketType"
  [initialQty]="initialDonationQty"
  (confirm)="onDonationConfirm($event)"
  (close)="closeDonationModal()"
></app-donation-ticket-modal>

<div class="main" id="event_single_page">
  <app-not-available
    *ngIf="!loading && event == null; else details"
    message="Este evento no está disponible"
  ></app-not-available>
  <ng-template #details>
    <app-detail-skeleton *ngIf="loading"></app-detail-skeleton>

    <section *ngIf="!loading" #detailSection class="my-2">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-md col-lg-6">
            <div class="event-single-gallery">
              <!-- Event carousel -->
              <event-carousel
                [square]="true"
                [banners]="banners"
              ></event-carousel>
              <app-play-video
                *ngIf="event?.videoId"
                [videoId]="event!.videoId || ''"
                ideoplay="Mirar"
                videotitle="Mis hijos se burlan de mi español"
              >
              </app-play-video>
              <!-- Event carousel -->
            </div>
          </div>
          <div class="col-12 col-md-auto col-lg-6">
            <article class="event-single-information">
              <h1 class="h1 mt-4 mb-4">{{ event?.name }}</h1>

              <ul class="list-group mt-3 mb-4">
                <li
                  class="list-group-item bg-transparent px-0 py-0 pt-1 border-0 align-items-center d-flex mb-1"
                >
                  <span class="material-symbols-outlined me-2"
                    >calendar_month</span
                  >
                  <p class="my-2 text-truncate h6 fw-normal">
                    {{ soonerDate | dateFormat }}
                  </p>
                </li>
                <li
                  *ngFor="let place of places"
                  class="list-group-item bg-transparent px-0 py-0 pt-1 border-0 align-items-center d-flex"
                >
                  <span class="material-symbols-outlined me-2"
                    >location_on</span
                  >
                  <p class="my-2 text-truncate h6 fw-normal">
                    {{ place }}
                  </p>
                </li>

                <li
                  class="list-group-item bg-transparent px-0 py-0 pt-1 border-0 align-items-center d-flex"
                  *ngIf="!event?.twoDMapUri && (event?.mapImageUri !== null || isThreeDMap())"
                >
                  <button
                    class="btn btn-outline-dark rounded rounded-pill mt-3 btn-sm px-3"
                    (click)="openMap()"
                  >
                    Ver mapa del evento
                  </button>
                </li>

                <div *ngIf="isOpen" class="threed-wism-backdrop"></div>
                <div class="threed-wism-container" *ngIf="isOpen">
                  <span
                    class="material-symbols-outlined icon-button cursor-pointer close-btn"
                    style="color: #fff; cursor: pointer"
                    (click)="closeMap()"
                  >
                    close
                  </span>
                  <iframe
                    src="https://static.pacifa3d.com/StadeJulianJavierSANFRANCISCODEMACORIS/WIMS/GC_BASEBALL_v2025-2026_2/full.html"
                    width="100%"
                    frameborder="0"
                    allowfullscreen
                    class="threed-wism"
                  ></iframe>
                </div>
              </ul>

              <!-- Event tickets -->

              <event-ticket
                *ngIf="isOpenTicketsSelection"
                [ticketTypeList]="ticketTypeList"
                [event]="event"
                [products]="products"
                [eventMapImgSrc]="event?.mapImageUri ?? ''"
                [event2dMapSrc]="event?.twoDMapUri || ''"
                (onProductChangeEvent)="onProductChangeListener($event)"
                (goToCheckout)="proceedToCheckout()"
              ></event-ticket>

              <!-- Event tickets -->

              <div class="form_buy-tickets" *ngIf="!event?.twoDMapUri">
                <button
                  class="d-flex justify-content-between align-items-center btn btn-dark rounded rounded-pill py-3 px-4 btn-lg w-100"
                  [disabled]="disabledToCheckout || proceeding"
                  (click)="proceedToCheckout()"
                >
                  <label class="h6 m-0">{{ proceeding ? "Cargando..." : actionText }}</label>
                  <ng-container *ngIf="proceeding">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="visually-hidden">Loading...</span>
                  </ng-container>
                  <data
                    *ngIf="!proceeding && !event?.free"
                    class="amount-sumary h6 m-0 fw-normal"
                    value="0.00"
                    >RD${{ totalAmount | number }}</data
                  >
                </button>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>

    <!-- Event vendor -->
    <event-vendor [event]="event"></event-vendor>
    <!-- Event vendor -->
  </ng-template>
</div>

<button
  style="visibility:hidden;"
  #openEmailFormBtn
  id="open-email-form-btn"
  data-bs-toggle="modal"
  data-bs-target="#email_form">
</button>

<!-- MODAL EMAIL FORM -->
<div
  class="modal fade"
  id="email_form"
  tabindex="-1"
  aria-labelledby="emailFormLabel"
  aria-hidden="true"
>

  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="emailFormLabel">Ingresar Correo</h1>
        <button
          #close_modal
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>


      <div class="modal-body">
        <form
        id="send-email-form"
        [formGroup]="sendEmailForm"
        (submit)="handleEmailSubmit()"
        >
          <div class="mb-3 form-floating">
            <input
              appFormInput
              formControlName="email"
              type="email"
              class="form-control"
              id="emailInput"
              placeholder="name@example.com"
            />
            <label for="emailInput" class="form-label"
              >Correo electrónico</label
            >
            <div class="invalid-feedback" *ngIf="emailInvalid">
              Este no es un correo válido
            </div>
          </div>
        </form>
      </div>

          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-outline-dark rounded-pill px-3"
              data-bs-dismiss="modal"
              (click)=closeEmailForm()
            >
              Cancelar
            </button>
            <button
              form="send-email-form"
              type="submit"
              class="btn btn-dark rounded-pill px-4"
              [disabled]="sendEmailForm.invalid"
            >
              Enviar
            </button>
        </div>
    </div>

</div>



